import { render, staticRenderFns } from "./ExpertResult.vue?vue&type=template&id=c6e3c8ca&scoped=true"
import script from "./ExpertResult.vue?vue&type=script&lang=js"
export * from "./ExpertResult.vue?vue&type=script&lang=js"
import style0 from "./ExpertResult.vue?vue&type=style&index=0&id=c6e3c8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e3c8ca",
  null
  
)

export default component.exports